<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('notifications.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs3>
              <v-autocomplete
                v-model="search_params.tenant_id"
                :items="tenants"
                item-text="subdomain"
                item-value="id"
                :label="$t('tennants.title')"
                autocomplete="new-password"
                @change="filter"
                clearable
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-model="search_params.type"
                :items="$dd_notification_type()"
                item-text="text"
                item-value="key"
                :label="$t('notifications.type')"
                @change="filter"
                hide-details
                clearable
              >
              </v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-model="search_params.status"
                :items="$dd_notification_status()"
                item-text="text"
                item-value="key"
                :label="$t('notifications.status')"
                @change="filter"
                hide-details
                clearable
              >
              </v-select>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link :to="BACKEND_URL + '/notifications/create'" v-if="$can('notification-create')">
        <action-button type="new" />
      </router-link>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="notifications"
            :items-per-page="notifications.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.type="{ item }">
              {{ $dd_notification_type(item.type) }}
            </template>
            <template v-slot:item.status="{ item }">
              {{ $dd_notification_status(item.status) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{
                  path: BACKEND_URL + '/notifications/edit/' + item.id,
                  props: { id: item.id }
                }"
                v-if="$can('notification-edit')"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <action-button type="delete" @click="del(item.id)" v-if="$can('notification-delete')" :icon_only="true" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "NotificationList",

  data() {
    return {
      url: "",
      notifications: [],
      tenants: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__notificationListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: [false]
      },
      search_params: {
        any: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("tennants.subdomain"), value: "subdomain" },
          { text: this.$t("notifications.header"), value: "header" },
          { text: this.$t("notifications.start_date"), value: "start_date" },
          { text: this.$t("notifications.start_time"), value: "start_time" },
          { text: this.$t("notifications.end_date"), value: "end_date" },
          { text: this.$t("notifications.end_time"), value: "end_time" },
          { text: this.$t("notifications.type"), value: "type" },
          { text: this.$t("notifications.status"), value: "status" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false
          }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__filter_Notification_List", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__sort_Notification_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__notificationListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "notifications"
    if (localStorage.getItem("__filter_Notification_List")) {
      this.search_params = JSON.parse(localStorage.getItem("__filter_Notification_List"))
    }
  },

  created() {
    let lists = [
      {
        key: "tenants",
        module: "tenants",
        query: "show_all=true&query_type=1&query_status=1"
      }
    ]
     axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.tenants = res.data.tenants
      this.tenants = [{ id: -1, subdomain: "[ " + this.$t("global.sb_title") + " ]" }, ...this.tenants]
     })
  },

  methods: {
    list() {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_Notification_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_Notification_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.notifications = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(action = null) {
       this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
       this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "notification/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
